import { render, staticRenderFns } from "./TopAdviceListItem.vue?vue&type=template&id=39dd7ec0&scoped=true&"
import script from "./TopAdviceListItem.vue?vue&type=script&lang=js&"
export * from "./TopAdviceListItem.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./TopAdviceListItem.vue?vue&type=style&index=0&id=39dd7ec0&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "39dd7ec0",
  "e361cb72"
  
)

export default component.exports